import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AlertNotice } from './alert.interface';

@Injectable({
  providedIn: 'root'
})
export class AlertNoticeService {
  onNoticeChanged$: BehaviorSubject<AlertNotice>;

  constructor() {
    this.onNoticeChanged$ = new BehaviorSubject(null);
  }

  setNotice(message: string, type?: string) {
    const notice: AlertNotice = {
      message,
      type
    };
    this.onNoticeChanged$.next(notice);
  }
}
